import { css } from "@emotion/react"

export const couponStyle = css`
	display: flex;
	flex-direction: row;
	align-items: center;

	button {
		margin-left: 1rem;
		margin-bottom: 1rem;
		width: 8.75rem;
	}
`

export const appliedCoupons = css`
	display: flex;
	margin-bottom: 1rem;
	flex-wrap: wrap;

	.coupon-chip {
		margin-right: 1rem;
		margin-bottom: 1rem;
	}

	.coupon-chip:last-child {
		margin-right: 0;
		margin-bottom: 0;
	}
`
